import { Button, Spin } from 'antd'
import React, { Component } from 'react'
import { ListTicket } from '../../network/profile.network'
import localization from '../../Localization/Localization.json'

export default class TicketList extends Component {

    state = {
        listTicket : [],
        isLoading : false
    }

    componentDidMount() {
        this.setState({isLoading : true})
        ListTicket(res => {
            console.log(res)
            if(res.data.code === 200){ 
                this.setState({ listTicket : res.data.data.tickets, isLoading : false })
                if(res.data.data.tickets.length === 0){
                    this.props.showEmptyIssue();
                }
            }
        }, error => {
            this.setState({isLoading : false})
            console.log(error) 
        })
    }

    render() {
        const {currentLang} = this.props;  
        return (
            <div className="ticket-list-wrapper">
                <Spin spinning={this.state.isLoading}>
                <div className="ticket-list-header">
                    <h5>{localization.YourPreviousissues[currentLang]}</h5>
                    <Button className="primary-light" size="large" type="primary" 
                    onClick={() => this.props.showNewIssue()}>{localization.newIssue[currentLang]}</Button>
                </div>
                <div className="ticket-list-content">
                    {this.state.listTicket.map(ticket => 
                    <div className="single-ticket-holder">
                        <div className="single-ticket-top"> 
                            <h6>{ticket.support_type.name}</h6>
                            {ticket.status === 0 ? <p className="open">{localization.Open[currentLang]}</p> : <p>{localization.Closed[currentLang]}</p>}
                        </div>
                        <div className="single-ticket-bottom">
                        {ticket.message}
                        </div>
                    </div>
                        )}
                </div>
                </Spin>
            </div>
        )
    }
}
